import React, { Component } from "react";
import PropTypes from "prop-types";
import t from "@zendesk/client-i18n-tools";

import AuthorFilter from "./AuthorFilter";
import BrandFilter from "./BrandFilter";
import CategoryFilter from "./CategoryFilter";
import FilterTag from "./FilterTag";
import LabelFilter from "./LabelFilter";
import OriginFilter from "./OriginFilter";
import PermissionGroupFilter from "./PermissionGroupFilter";
import UserSegmentFilter from "./UserSegmentFilter";
import SectionFilter from "./SectionFilter";
import YesNoFilter from "./YesNoFilter";

import yesNoFilters from "state/yesNoFilters";

export default class Filter extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.any,
  };

  render() {
    const { onClick, type, value } = this.props;

    if (yesNoFilters.includes(type)) {
      return <YesNoFilter onClick={onClick} type={type} value={value} />;
    }

    switch (type) {
      case "author":
        return <AuthorFilter onClick={onClick} type={type} value={value} />;
      case "brand":
        return <BrandFilter onClick={onClick} type={type} value={value} />;
      case "label":
        return <LabelFilter onClick={onClick} type={type} value={value} />;
      case "origin":
        return <OriginFilter onClick={onClick} type={type} value={value} />;
      case "category":
        return <CategoryFilter onClick={onClick} type={type} value={value} />;
      case "section":
        return <SectionFilter onClick={onClick} type={type} value={value} />;
      case "permissionGroup":
        return (
          <PermissionGroupFilter onClick={onClick} type={type} value={value} />
        );
      case "userSegment":
        return (
          <UserSegmentFilter onClick={onClick} type={type} value={value} />
        );

      case "updated":
      case "created":
        return (
          <FilterTag
            onClick={onClick}
            type={type}
            value={t(`knowledge-verification.${value}`)}
          />
        );

      default:
        return <FilterTag onClick={onClick} type={type} value={value} />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/index.js